import { render, staticRenderFns } from "./CreateVehicleModal.vue?vue&type=template&id=1a51add0&"
import script from "./CreateVehicleModal.vue?vue&type=script&lang=ts&"
export * from "./CreateVehicleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports